<template>
    <table class="questions">
        <thead>
            <tr>
                <th style="width: 60px">排序</th>
                <th style="width: 60px">序号</th>
                <th style="width: 88px">题目类型</th>
                <th>题目</th>
                <th style="width: 107px">操作</th>
            </tr>
        </thead>
        <tbody ref="sortTable">
            <template v-for="(question, i) in questions">

                <tr class="question-item" :key="question.id" :data-name="question.title" :data-id="question.id">
                    <td class="content">
                        <div class="icon drag-handle">
                            <img src="/assets/images/question-sort.png">
                        </div>
                    </td>
                    <td class="content">
                        <div class="index">{{ i + 1 }}</div>
                    </td>
                    <td class="content">
                        <div class="type">{{ getTypeText(question.type) }}</div>
                    </td>
                    <td class="content">
                        <span class="text-danger" v-if="question.required">*</span>
                        {{ question.title }}
                    </td>
                    <td class="content">
                        <div class="op-btn" @click="editQuestion(question)">编辑</div>
                        <div class="line"></div>
                        <div class="op-btn" @click="insertQuestion(i)">插入</div>
                    </td>
                </tr>

            </template>
        </tbody>
    </table>
</template>

<script>
import Sortable from "sortablejs";
export default {
    name: "Question",
    props: {
        questions: {
            type: Array,
            default() {
                return []
            }
        }
    },
    data() {
        return {
            dragStartIndex: -1,
            dragOverIndex: -1
        }
    },
    mounted() {
        this.initSortAble()
    },
    methods: {
        initSortAble() {
            const tbody = this.$refs.sortTable;
            
            // 使用Sortable.js实现拖拽排序
            Sortable.create(tbody, {
                handle: '.drag-handle',
                animation: 150,
                ghostClass: 'sortable-ghost',
                chosenClass: 'sortable-chosen',
                dragClass: 'sortable-drag',
                filter: 'thead',
                onEnd: () => {
                    // 获取拖拽后的新位置
                    const newList = [];
                    tbody.querySelectorAll('tr').forEach(row => {
                        // 获取每个行的data-id属性
                        const id = row.getAttribute('data-id');
                        if (id) {
                            newList.push(id);
                        }
                    });
                    this.saveSort(newList);
                }
            });
        },
        saveSort(newList) {
            console.log('newList',newList);
            // 触发事件让父组件保存排序
            this.$emit('saveSort', newList);
        },
        getTypeText(type) {
            if (type === 'radio') {
                return '单选题'
            } else if (type === 'checkbox') {
                return '多选题'
            } else if (type === 'text') {
                return '问答题'
            } else {
                return ''
            }
        },
        editQuestion(question) {
            this.$emit('edit', question)
        },
        insertQuestion(index) {
            this.$emit('insert', index)
        },
    },

}
</script>

<style scoped lang="less">
.questions {
    width: 100%;
    thead{
        border: 1px solid #EEEEEE;
        th{
            height: 40px;
            line-height: 40px;
            text-align: center;
            color: #999999;
            font-weight: 400;
            &:nth-child(3),&:nth-child(4) {
                text-align: left;
                padding-left: 16px;
            }
        }
    }
    tbody{
        border: 1px solid #EEEEEE;
    }

    .question-item {

        .content {
            height: 40px;
            line-height: 40px;
            color: #333333;
            font-size: 14px;
            margin: 10px 0;

            &:nth-child(1) {
                width: 60px;
                text-align: center;

                .icon {
                    width: 100%;
                    height: 100%;
                    display: flex;
                    align-items: center;
                    justify-content: center;

                    img {
                        width: 16px;
                        height: 16px;
                    }
                }
            }
            &:nth-child(2) {
                width: 60px;
                text-align: center;
            }
            &:nth-child(3) {
                width: 88px;

                .type {
                    width: 66px;
                    height: 40px;
                    background: #F7F7F7;
                    text-align: center;
                    margin: 0 auto;
                    color: #333333;
                    font-size: 14px;
                    font-weight: bold;
                }
            }

            &:nth-child(4) {
                flex: 1;
                padding-left: 16px;
            }

            &:nth-child(5) {
                width: 107px;
                display: flex;
                align-items: center;
                justify-content: space-between;

                .op-btn {
                    width: calc(50% - 1px);
                    height: 100%;
                    line-height: 40px;
                    text-align: center;
                    color: #FBB03B;
                    font-size: 14px;
                    cursor: pointer;
                }

                .line {
                    width: 1px;
                    height: 16px;
                    background-color: #999999;
                }
            }
        }
    }
}
</style>